import axiosPost from "./axiosPost";

export const usuarioBasicosGet = async ({
    usuarioNroDeDocumento,
    usuarioSexo,
    usuarioFechaDeNacimiento,
    tipoDeDocumentoId,
}, credentials) => {
    const body = {
        service: "UsuarioBasicosGet",
        params: {
            usuarioNroDeDocumento,
            usuarioSexo,
            usuarioFechaDeNacimiento,
            tipoDeDocumentoId,
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
